<template>
  <v-ons-page @show="showArcValue = true">

    <div class="content">

      <app-pull-hook :disabled="isSync" @call-api="$emit('call-api', $event)"></app-pull-hook>

      <div v-if="! listVentes.length" class="content--perfhome content--perfhome__empty">

        <header>
          <img :src="$getBadgeAsset(nbFeuille)">
        </header>
        <section>
          <p>Ajoutez vos cultures pour suivre l'avancement de vos ventes.</p>
        </section>
        <footer>
          <v-ons-button modifier="large--cta perflarge" @click="$emit('show-home', { id: 'cultures' })">
            Ajouter mes cultures
          </v-ons-button>
        </footer>

      </div>

      <div v-else class="content--perfhome">

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item v-for="(item, index) in listVentes" :key="index"
                           modifier="chevron perfvente" @click="showVenteListe(item.refCulture, item.refDestination)" tappable>
            <div class="left">
              <div class="pie-wrapper">
                <div class="arc" :data-value="showArcValue ? item.arcValue : 0"></div>
                <p class="perfdetail-score">
                  <span>{{ item.tonneTotal !== '' ? Math.round(item.tonneTotal).toLocaleString('fr') : '__' }} t</span>
                </p>
              </div>
            </div>
            <div class="center">
              <span class="list-item__title">
                {{ item.label }}
                <img v-if="item.isBio" src="../assets/imgs/bio_carre@2x.png">
              </span>
              <span class="list-item__subtitle" :style="item.tonneVendre === 0 ? 'text-decoration: line-through' : ''">
                Reste à vendre : {{ item.tonneVendre !== '' ? item.tonneVendre.toLocaleString('fr') : '__' }} t
                <template v-for="ledLabel in item.ledList">
                  <br :key="ledLabel"/>
                  {{ ledLabel }}
                </template>
              </span>
            </div>
            <div class="right">
              <span v-if="item.notif" class="notification">{{ item.notif }}</span>
              <span v-else-if="item.prixMoyen">{{ item.prixMoyen.toLocaleString('fr') }}&nbsp;€/t</span>
              <span v-else class="label-grey">__&nbsp;€/t</span>
            </div>
          </v-ons-list-item>

        </v-ons-list>

      </div>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppPullHook from '../partials/PullHook.vue';

import AppVenteListe from './VenteListe.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppPullHook },
  props: ['pageStack', 'initInfos'],
  data() {
    return {
      showArcValue: false,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    isSync() {
      return this.state.isSync;
    },
    referentiel() {
      return this.data.referentiel;
    },
    notifState() {
      return this.state.notif;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isTech() {
      return this.negoce[0] && this.negoce[0].is_tech;
    },
    clientInfos() {
      if(this.isTech){
        return this.getClientInfosTech(this.data.negoce.clients, this.clientConnect.id);
      }
      return null;
    },
    listVentes() {
      var list = [];
      for (const refCulture in this.user.ventes) {
        for (const refDestination in this.user.ventes[refCulture]) {
          var strategie = this.user.ventes[refCulture][refDestination];
          var cours = this.user.seuil.cours[refCulture][refDestination];

          if (!strategie.done) {
            continue;
          }

          var arcValue = 0;
          var tonneTotal = '';
          if(this.isTech){
            var clientConnectInfos = this.getClientConnectInfos(this.clientConnect.id, strategie);
            if(clientConnectInfos.surface === 0){
              continue;
            }
            tonneTotal = this.getTonneTotalClient(clientConnectInfos);
          } else {
            tonneTotal = this.getTonneTotal(this.user.cultures, refCulture, refDestination, strategie.tonne);
          }
          var tonne_vendu = this.getTonneVendu(strategie.done, this.clientConnect.id);
          if(tonneTotal !== ''){
            arcValue = Math.min(100, Math.round(100 * tonne_vendu / tonneTotal));
          }

          // Reste à vendre
          var tonneVendre = tonneTotal;
          if (tonneVendre){
            tonneVendre -= tonne_vendu;
            tonneVendre = Math.max(0, Math.round(tonneVendre * 1000) / 1000);
          }

          // prix moyen
          var prixMoyen = this.getPrixMoyen(strategie.done, this.clientConnect.id);

          var notif = this.getCultureNotifCount(strategie.done, this.negoce, refCulture, refDestination, this.notifState);

          var ledGroup = {};
          if(this.isTech){
            if(this.clientInfos
            && this.clientInfos.led
            && this.clientInfos.led[this.campagne]
            && this.clientInfos.led[this.campagne][refCulture]
            && this.clientInfos.led[this.campagne][refCulture][refDestination]){
              var ledList = this.clientInfos.led[this.campagne][refCulture][refDestination];
              var negoceItem = this.negoce[0];
              if(this.clientInfos.negoce){ // dans le cas du multi-OS on prend le bon negoceItem
                for (let i = 0; i < this.negoce.length; i++) {
                  var negoceItem = this.negoce[i];
                  if(negoceItem.id == this.clientInfos.negoce){
                    break;
                  }
                }
              }
              var configLabel = this.getConfigLabel(negoceItem, this.campagne, refCulture, refDestination);
              this.setLedGroup(ledGroup, ledList, {}, configLabel);
            }
          } else {
            for (let i = 0; i < this.negoce.length; i++) {
              var negoceItem = this.negoce[i];
              if(negoceItem.led
              && negoceItem.led[this.campagne]
              && negoceItem.led[this.campagne][refCulture]
              && negoceItem.led[this.campagne][refCulture][refDestination]){
                var ledList = negoceItem.led[this.campagne][refCulture][refDestination];
                var configLabel = this.getConfigLabel(negoceItem, this.campagne, refCulture, refDestination);
                this.setLedGroup(ledGroup, ledList, negoceItem.clients, configLabel);
              }
              // TODO multi OS
            }
          }
          var ledLabelList = [];
          for (const ledClient in ledGroup) {

            if(ledClient){
              ledLabelList.push('> ' + ledClient);
            }

            for (const ledKey in ledGroup[ledClient]) {
              var ledItem = ledGroup[ledClient][ledKey];
              let ledLabel = ledItem.label;
              // Quand il n'y a pas de variété, on a juste ajouté le sotckage dans le label, on ajoute à posteriori la culture
              if (!ledLabel.includes(' • ')) {
                ledLabel = this.getCultLabel(refCulture, refDestination) + ' • ' + ledLabel;
              }
              ledLabelList.push(' • ' + ledItem.tonne.toLocaleString('fr') + 't ' + ledLabel);
            }
          }

          list.push({
            refCulture: refCulture,
            refDestination: refDestination,
            label: this.getCultLabel(refCulture, refDestination),
            isBio: cours.is_bio,
            arcValue: arcValue,
            tonneTotal: tonneTotal,
            tonneVendre: tonneVendre,
            prixMoyen: prixMoyen,
            notif: notif,
            ledList: ledLabelList
          });
        }
      }
      this.sortCultList(list);
      return list;
    }
  },
  watch: {
    initInfos() {
      this.setInitInfos();
    }
  },
  methods: {
    setInitInfos(){
      if (this.initInfos){
        var refCulture = this.initInfos.refCulture;
        var refDestination = this.initInfos.refDestination;
        if(refCulture == 'nd' && refDestination == 'nd' && this.listVentes.length){
          refCulture = this.listVentes[0].refCulture;
          refDestination = this.listVentes[0].refDestination;
        }
        if(this.user.ventes[refCulture] && this.user.ventes[refCulture][refDestination]) {
          this.showVenteListe(refCulture, refDestination, this.initInfos.path);
        }
      }
    },
    showVenteListe(refCulture, refDestination, initInfos) {
      this.pageStack.push({
        extends: AppVenteListe,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination,
            initInfos: initInfos
          }
        }
      });
    },
    setLedGroup(ledGroup, ledList, negoceClients, configLabel){
      for (let i = 0; i < ledList.length; i++) {
        var ledItem = ledList[i];
        var ledClient = ledItem.client ? negoceClients[ledItem.client] : '';
        var ledKey = JSON.stringify(ledItem.config || {});
        if(! ledGroup[ledClient]){
          ledGroup[ledClient] = {}
        }
        if(! ledGroup[ledClient][ledKey]){
          ledGroup[ledClient][ledKey] = {
            label: this.getLedLabel(ledItem, configLabel),
            tonne: 0
          }
        }
        ledGroup[ledClient][ledKey].tonne += ledItem.tonne;
      }
    },
    getLedLabel(ledItem, configLabel){
      var label = [];

      var ledItemConfig = ledItem.config || {};

      if(! ledItemConfig.stockage){
        ledItemConfig = JSON.parse(JSON.stringify(ledItemConfig));
        ledItemConfig.stockage = ['os'];
      }

      if(ledItemConfig){
        for (let i = 0; i < configLabel.length; i++) {
          var configLabelItem = configLabel[i];
          if(ledItemConfig[configLabelItem.id]){
            var configKey = ledItemConfig[configLabelItem.id][0];
            if(configLabelItem.label[configKey]){
              label.push(configLabelItem.label[configKey]);
            }
          }
        }
      }
      return label.join(' • ');
    },
    getConfigLabel(negoceItem, campagne, refCulture, refDestination){
      var configLabel = [];
      var configList = [];
      if(negoceItem.config_label){
        for (let i = 0; i < negoceItem.config_label.length; i++) {
          var configLabelItem = negoceItem.config_label[i];
          if(configLabelItem.campagne && configLabelItem.campagne != campagne){
            continue;
          }
          if(configLabelItem.refCulture && configLabelItem.refCulture != refCulture){
            continue;
          }
          if(configLabelItem.refDestination && configLabelItem.refDestination != refDestination){
            continue;
          }
          configLabel.push(configLabelItem);
          configList.push(configLabelItem.id);
        }
      }
      if(negoceItem.config){
        for (let i = 0; i < negoceItem.config.length; i++) {
          var negoceConfigItem = negoceItem.config[i]
          if(configList.includes(negoceConfigItem.id)){
            continue;
          }
          if(negoceConfigItem.campagne && negoceConfigItem.campagne != campagne){
            continue;
          }
          if(negoceConfigItem.refCulture && negoceConfigItem.refCulture != refCulture){
            continue;
          }
          if(negoceConfigItem.refDestination && negoceConfigItem.refDestination != refDestination){
            continue;
          }
          let configLabelItem = {
            id: negoceConfigItem.id,
            label: {}
          };
          for (let j = 0; j < negoceConfigItem.choix.length; j++) {
            var choixItem = negoceConfigItem.choix[j];
            configLabelItem.label[choixItem.id] = choixItem.label;
          }
          configLabel.push(configLabelItem);
          configList.push(negoceConfigItem.id);
        }
      }

      var configLabelStockage = {id: 'stockage', label: {}};
      for (let i = 0; i < configLabel.length; i++) {
        let configLabelItem = configLabel[i];
        if (configLabelItem.id == 'stockage') {
          configLabelStockage = configLabel.splice(i, 1)[0];
          break;
        }
      }
      configLabelStockage.label.os = 'Dépôt';
      configLabel.push(configLabelStockage);

      return configLabel;
    }
  },
  created() {
    this.setInitInfos();
  }
};
</script>

<style>
.list-item--perfvente .list-item__center {
  font-size: 14px;
  line-height: 17px;
}
.list-item--perfvente__subtitle {
  color: var(--perfarmer-gris-dark);
}
.list-item--perfvente:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 15px;
  right: 0;
  height: 1px;
  background-image: linear-gradient(0deg, #f2f4f8, #f2f4f8 100%);
}

.content--perfhome .pie-wrapper {
  width: 60px;
  height: 30px;
  margin: 0;
}
.content--perfhome .pie-wrapper .arc,
.content--perfhome .pie-wrapper::before {
  width: 60px;
  height: 30px;
}
.content--perfhome .pie-wrapper .arc {
  border-width: 5px;
  border-radius: 0 0 60px 60px;
}
.content--perfhome .pie-wrapper::before {
  border-width: 5px;
  border-radius: 60px 60px 0 0;
}
.content--perfhome .pie-wrapper .arc::before {
  content: none;
}

.list-item--chevron__right .notification {
  font-size: 12px;
  height: 18px;
  min-width: 18px;
  line-height: 18px;
  margin-left: 4px;
  margin-right: -4px;
}

.list-item--perfvente__right .label-grey {
  color: var(--perfarmer-gris-dark);
  opacity: 0.75;
}
.content--perfhome .perfdetail-score span {
  opacity: 0.75;
  font-size: 13px;
  margin-bottom: -2px;
  display: block;
  line-height: 13px;
}
</style>